<template>
	<Header />

	<div class="flex pt-5 px-10 pb-5 gap-10 min-h-[calc(100vh-80px)]">
		<Sidebar :isVisible="isSidebarVisible" />

		<div
			class="flex-1 min-w-0 transition-all duration-[800ms] pb-20"
			:data-sidebar-visible="isSidebarVisible"
		>
			<slot />
		</div>
	</div>
</template>

<script setup>
const isSidebarVisible = useState('isSidebarVisible', () => true)
</script>

<style scoped>
/* Obsah = zvyšok šírky vedľa fixného menu (w-full + margin pretekal doprava o šírku menu). */
[data-sidebar-visible='true'] {
	margin-left: calc(320px + 40px);
}
@media (max-width: 767px) {
	[data-sidebar-visible='true'] {
		margin-left: calc(240px + 40px);
	}
}
</style>
